module.exports = __webpack_public_path__ + "img/27-white.08c45c1f.svg";